import React from 'react';
import { Paper, Typography, Box, TextField, Button } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';

const ExamCodeSearchBar = ({ examCode, setExamCode, fetchExamResults, loading }) => (
  <Box display="flex" justifyContent="center" style={{ marginBottom: 32, marginTop: 8 }}>
    <Paper elevation={3} style={{ padding: 28, borderRadius: 14, maxWidth: 500, width: '100%' }}>
      <Typography variant="h5" gutterBottom style={{ fontWeight: 700, color: '#004085', marginBottom: 8 }}>
        Enter Exam Code
      </Typography>
      <Box display="flex" alignItems="center">
        <TextField
          label="Exam Code"
          variant="outlined"
          value={examCode}
          onChange={(e) => setExamCode(e.target.value)}
          placeholder="e.g., EXAM001"
          fullWidth
          InputProps={{ style: { height: 48, fontSize: 18 } }}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={fetchExamResults}
          disabled={loading}
          style={{
            height: 40,
            minWidth: 140,
            maxWidth: 140,
            fontWeight: 700,
            fontSize: 18,
            marginLeft: 12,
            boxShadow: '0 2px 8px rgba(33,150,243,0.08)',
            transition: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 8,
            textTransform: 'none'
          }}
        >
          {!loading && <SearchIcon style={{ marginRight: 6 }} />}
          {loading && (
            <span style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{ width: 18, height: 18, marginRight: 6, display: 'flex', alignItems: 'center' }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="10" stroke="#fff" strokeWidth="3" opacity="0.2"/>
                  <path d="M22 12c0-5.522-4.477-10-10-10" stroke="#fff" strokeWidth="3" strokeLinecap="round">
                    <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.8s" repeatCount="indefinite"/>
                  </path>
                </svg>
              </span>
            </span>
          )}
          <span>{loading ? 'Searching...' : 'Search'}</span>
        </Button>
      </Box>
    </Paper>
  </Box>
);

export default ExamCodeSearchBar; 